import { render, staticRenderFns } from "./AddService.vue?vue&type=template&id=222ca55c&scoped=true&"
import script from "./AddService.vue?vue&type=script&lang=js&"
export * from "./AddService.vue?vue&type=script&lang=js&"
import style0 from "./AddService.vue?vue&type=style&index=0&id=222ca55c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222ca55c",
  null
  
)

export default component.exports